import * as React from "react";
import "../filters.scss";
import RadioButton, {IRadioButton} from "../../../../hiberUiKit/src/atoms/Buttons/RadioButton";
import {none, option, Option} from "ts-option";
import {NumberFilterType, NumberFilterTypeName} from "./NumberFilter";
import NumberUtils from "../../../../utils/NumberUtils";
import NumberFilterModel from "../../../../model/workspace/NumberFilterModel";
import classNames = require("classnames");

interface IProps {
	/**
	 * Input value
	 */
	value: Option<NumberCompareFilterModel>
	/**
	 * On change callback
	 * @param {Option<MoreThanFilterModel>} value
	 */
	onChange: (value: Option<NumberCompareFilterModel>) => void
	/**
	 * Selected radio button Id
	 */
	selectedRadioButtonId: string
	/**
	 * On select button
	 * @param {string} id
	 */
	onSelectButton: (id: string) => void;
	/**
	 * Type of filter.
	 */
	filterType: NumberFilterType.Equal | NumberFilterType.LessThan | NumberFilterType.GreaterThan;
}

interface IState {
	/**
	 * Value to compare with.
	 */
	inputValue: string;
}

export default class NumberCompareFilter extends React.Component<IProps, IState> {
	radioButton: IRadioButton = {
		label: NumberFilterTypeName[this.props.filterType],
		disabled: false,
		value: this.props.filterType
	};

	constructor(props: IProps) {
		super(props);
		this.state = {inputValue: props.value.map(v => v.value.toString()).getOrElse("")};
		this.onChangeInput = this.onChangeInput.bind(this);
		this.onChangeCallback = this.onChangeCallback.bind(this);
		this.resetFilter = this.resetFilter.bind(this);
	}

	componentWillReceiveProps(nextProps: IProps) {
		if (this.props.selectedRadioButtonId === this.radioButton.value &&
			nextProps.selectedRadioButtonId !== this.radioButton.value) {
			this.resetFilter();
		}
	}

	render() {
		const classFromProps = classNames({
			"c-filter_numbers_input": true,
			"greater-than": this.props.filterType === NumberFilterType.GreaterThan,
			"less-than": this.props.filterType === NumberFilterType.LessThan,
			"equal-to": this.props.filterType === NumberFilterType.Equal
		});
		const radioButtonChecked = (this.props.selectedRadioButtonId === this.radioButton.value);
		return (
			<div className={"c-filter-dates_inputs_row"}>
				<RadioButton radioButton={this.radioButton}
							 onChange={() => this.props.onSelectButton(this.radioButton.value)}
							 checked={this.props.selectedRadioButtonId === this.radioButton.value}/>
				<input className={classFromProps}
					   type="number"
					   value={this.state.inputValue}
					   onChange={this.onChangeInput}
					   disabled={!radioButtonChecked}/>
			</div>
		);
	}

	/**
	 * Callback on change input.
	 */
	onChangeInput(e: React.FormEvent<HTMLInputElement>) {
		if (e.currentTarget.value.length == 0 || NumberUtils.isNumber(e.currentTarget.value)) {
			this.setState({inputValue: e.currentTarget.value}, this.onChangeCallback);
		}
	}

	/**
	 * On any change callback
	 */
	onChangeCallback() {
		if (this.state.inputValue) {
			this.props.onChange(option(new NumberCompareFilterModel(Number(this.state.inputValue), this.props.filterType)));
		}
		else {
			this.props.onChange(none);
		}
	}

	/**
	 * Reset filter
	 */
	resetFilter() {
		this.setState({inputValue: ""});
	}
}

export class NumberCompareFilterModel extends NumberFilterModel {
	constructor(public readonly value: number, filterType: NumberFilterType) {
		super(filterType);
	}

	static fromJson(json: number[], filterType: NumberFilterType) {
		return new NumberCompareFilterModel(json[0], filterType);
	}

	getDisplayValue(): string {
		return `${super.getDisplayValue()} ${this.value}`;
	}

	toQueryJson() {
		return [this.value];
	}
}
